export enum TABS_URL_VALUES {
  Features = 'features',
  Users = 'users',
  EmailDomains = 'email-domains',
  MFA = 'mfa',
  Integrations = 'integrations',
  AuditLog = 'audit-log',
}

// Appended only, never reordered: the tab index maps to TabPanel order and
// the enum values live in bookmarked ?activeTab= URLs.
export const tabsArray: TABS_URL_VALUES[] = [
  TABS_URL_VALUES.Features,
  TABS_URL_VALUES.Users,
  TABS_URL_VALUES.EmailDomains,
  TABS_URL_VALUES.MFA,
  TABS_URL_VALUES.Integrations,
  TABS_URL_VALUES.AuditLog,
];
export const tabsIndexMap: Record<TABS_URL_VALUES, number> = tabsArray.reduce(
  (acc, tab, index) => {
    acc[tab] = index;
    return acc;
  },
  {} as Record<TABS_URL_VALUES, number>
);

export type UrlStateType = {
  activeTab: TABS_URL_VALUES;
};

export enum EnableDisableValue {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

export const toEnableDisableValue = (isEnabled: boolean): EnableDisableValue =>
  isEnabled ? EnableDisableValue.Enabled : EnableDisableValue.Disabled;

export const isEnabledValue = (value: string): boolean =>
  value === EnableDisableValue.Enabled;

export const enableDisableRadioButtonOptions = [
  {
    id: 'enabled',
    label: 'Enabled',
    value: EnableDisableValue.Enabled,
  },
  {
    id: 'disabled',
    label: 'Disabled',
    value: EnableDisableValue.Disabled,
  },
];

export const yesNoRadioButtonOptions = [
  {
    id: 'yes',
    label: 'Yes',
    value: EnableDisableValue.Enabled,
  },
  {
    id: 'no',
    label: 'No',
    value: EnableDisableValue.Disabled,
  },
];

// Labels for the "ATS AI Interview results" setting. "Assessment order
// only" maps to the flag being disabled (no result link is sent);
export const generateRadioButtonOptions = [
  {
    id: 'generate',
    label: 'Generate',
    value: EnableDisableValue.Enabled,
  },
  {
    id: 'do-not-generate',
    label: 'Do not generate',
    value: EnableDisableValue.Disabled,
  },
];
